import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  items?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSoftware',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



const { $config } = useContext();

const filterLink = (path: string) => {
  const isExternalLink = /^https?:/.test(path);

  if (isExternalLink) {
    return path;
  }

  return `${$config.fullPath}${path}`;
};

return { __sfc: true,$config, filterLink, CdnImg, handleImageSrc, handleImageAlt }
}

})